var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWalkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8.62 1.2 32.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.35185,
    y: 17.2037,
    width: 6.72361,
    height: 15.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.62965,
    cy: 6.20345,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.95005,30.26715l2.0251-12.42a4,4,0,0,0-3.9478-4.6437h-2.398a2.00031,2.00031,0,0,0-1.3015.4814l-7,6a1.9994,1.9994,0,0,0-.5329.7224l-2.9866,6.8906a2.08621,2.08621,0,0,0,.902,2.6989,1.999,1.999,0,0,0,2.7242-1.0057l2.8499-6.5718,3.3987-2.9132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.59355,26.47975l-1.8599,11.9039-6.6151,8.5049a2.07687,2.07687,0,0,0,.0512,2.6832,2.00131,2.00131,0,0,0,3.0385-.1403L20.117,40.549a3.00078,3.00078,0,0,0,.5569-1.1753l1.4415-6.3257"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.68315,19.506l-1.0896,6.9737a4,4,0,0,0,.7985,3.0782l7.4017,9.4853,2.9204,9.7349a1.9996,1.9996,0,0,0,2.8635,1.1868,2.08587,2.08587,0,0,0,.9332-2.4505c-.6987-2.3291-2.4569-8.1898-2.9279-9.7598a2.95545,2.95545,0,0,0-.3407-.7427l-4.2922-6.7448"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.42025,21.25005l2.6673,3.2273a2.00106,2.00106,0,0,0,.9092.6236l6,2a2.00009,2.00009,0,0,0,1.2647-3.795l-5.4561-1.8183-5.7884-6.9415"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalkWhite);
export default __webpack_public_path__ + "static/media/icon_walk_white.f5390d11dc446a7d9a201a847fdd81fc.svg";
export { ForwardRef as ReactComponent };